<template>
    <div class="page7">
        <b-container>
            <b-row class="d-lex justify-content-center mt-5">
                <b-col lg="8" >
                    <div class="box-tks mt-5 p-5 h2 text-center d-flex align-items-center justify-content-center" v-if="pageSlug == 'placementtest3' || pageSlug == 'prepare-x'">
                        <div class="text-center">
                            <p>Cảm ơn bạn đã hoàn thành xuất sắc bài thi.</p>
                            <p>Rất mong được đồng hành với bạn trong thời gian tới!</p>
                        </div>
                    </div>
                    <div class="mt-5" v-else>
                        <img src="~@/assets/tks.png" alt="">
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    export default {
        computed: {
            pageSlug () {
                return this.$route.params.slug
            }
        }
    }
</script>
<style >

    .box-tks {
        background-color: #fee138;
        border-radius: 42px;
        color: #0057a7;
        min-height: 400px;
    }

    .box-tks p {
        font-size: 25px;
        text-align: center;
        font-weight: 800;
        text-shadow: 2px 2px #fff,
                     2px -2px #fff,
                    -2px 2px #fff,
                    -2px -2px #fff;
    }

    .check-box span{
        background: #fee138;
        color: #1160a0;
        font-style: italic;
        padding: 5px 15px;
        border-radius: 10px;
        border: 2px solid #1160a0;
        margin-left: 30px;
    }
    .check-box{
        margin-bottom: 40px;
    }
    .check-box input[type="checkbox"]{
        width: 30px;
        height: 25px;
        /* -webkit-appearance: none;
        -moz-appearance: none;
        -o-appearance: none;
        appearance: none; */
        border: 2px solid #1160a0;
        border-radius: 4px;
        outline: none;
        transition-duration: 0.3s;
        cursor: pointer;
        margin-right: 30px;
        margin-top: -3px;
    }
    .form-box input[type="text"]{
        border: 2px solid #1160a0;
        border-radius: 8px;
    }
</style>
<style scoped>
    .box_test{
        /* height: 70vh; */
        background: #fff;
        border-radius: 20px;
        background: url(~@/assets/bg-box-test.png);
        background-repeat: repeat;
        /* overflow-y: scroll; */
        position: relative;
        box-shadow: 0px 8px 0px #1990ef;
    }
    .dotted{
        position: absolute;
        width: 93%;
        top: -2px;
        background: url(~@/assets/dotted-box-test.png);
        background-repeat: repeat-x;
        height: 55px;
        left: 50%;
        transform: translateX(-50%);
    }
    .container-test{
        text-align: center;
        padding: 40px;

    }
    .container-test  h2{
        margin-top: 20px;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.5;
        color: #fee138;
        text-shadow: rgb(0, 87, 167) 2px 0px 0px, rgb(0, 87, 167) 1.75517px 0.958851px 0px, rgb(0, 87, 167) 1.0806px 1.68294px 0px, rgb(0, 87, 167) 0.141474px 1.99499px 0px, rgb(0, 87, 167) -0.832294px 1.81859px 0px, rgb(0, 87, 167) -1.60229px 1.19694px 0px, rgb(0, 87, 167) -1.97998px 0.28224px 0px, rgb(0, 87, 167) -1.87291px -0.701566px 0px, rgb(0, 87, 167) -1.30729px -1.5136px 0px, rgb(0, 87, 167) -0.421592px -1.95506px 0px, rgb(0, 87, 167) 0.567324px -1.91785px 0px, rgb(0, 87, 167) 1.41734px -1.41108px 0px, rgb(0, 87, 167) 1.92034px -0.558831px 0px;
    }
    .container-test h3{
        font-size: 20px;
        color: #0057a7;
        font-weight: 900;
    }
    .container-test h4, .end-form p{
        font-size: 20px;
        color: #0057a7;
        margin-bottom: 0;
        font-weight: 600;
        font-style: italic;
    }
    .container-test form{
        max-width: 1000px;
        margin: 0 auto;
        margin-top: 30px;
    }
    .form-box .col-lg-4{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .box_test{
        /* margin-top: 30px; */
    }
    .end-form input{
        width: 100%;
        height: 40px;
        line-height: 40px;
    }
    .end-form{
        display: flex;
        align-items: center;
    }
    .end-test{
        font-size: 30px;
        color: #0057a7;
        font-weight: 600;
        display: flex;
        align-items: baseline;
        justify-content: center;
        margin-top: 40px;
    }
     .end-test img{ margin-right: 20px;}
    @media only screen and (max-width: 768px){
         .dotted{
            width: 100%;
            background-size: 30%;
        }
        .btn-custom.btn-success{
            font-style: 25px;
        }
        .page7{
            height: 85vh;
        }
     }
</style>
